var React = require('react');

function StatusPending (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"8","cy":"8","r":"8","fill":"#FFB800"}));
}

StatusPending.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = StatusPending;

StatusPending.default = StatusPending;
